import { Button, CircularProgress, TextField } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { MdAdd, MdClose, MdDelete, MdEdit } from 'react-icons/md';
import styles from './ProductTypeEditor.module.css';
import { Formik } from 'formik';
import Divider from 'components/common/Divider/Divider';
import { DataGrid } from '@mui/x-data-grid';
import ProductTypeDialog from '../ProductTypeDialog/ProductTypeDialog';
import { Grow, IconButton, Tooltip } from '@mui/material';
import ConfirmDialog from 'components/common/ConfirmDialog/ConfirmDialog';
import productTypeValidator from './ValidationSchema';
import { useTranslation } from 'react-i18next';
const ProductTypeEditor = ({
  selectedEdit,
  onClose,
  datagridData,
  handleDialogSubmit,
  handleDialogClose,
  dialogOpen,
  setDialogOpen,
  handleSubmit,
  edit,
  setEdit,
  deleteModifier,
  createModifier,
  updateModifier,
  createPrio2Modifier,
  updatePrio2Modifier,
  setIsEdit,
  prio2Modifiers
}) => {
  const { t } = useTranslation();
  const [sureOpen, setSureOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(true);
  const columns = [
    { field: 'id', headerName: 'ID', flex: 1 },
    {
      field: 'name',
      headerName: t('common.name'),
      flex: 2,
      editable: false
    },
    {
      field: 'description',
      headerName: t('common.description'),
      flex: 4,
      editable: false
    },
    {
      field: 'category',
      headerName: t('common.category'),
      flex: 2,
      editable: false
    },
    {
      field: 'actions',
      headerName: t('common.actions'),
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        return (
          <div style={{ display: 'flex', gap: '8px' }}>
            <IconButton
              onClick={() => {
                setEdit(prio2Modifiers?.find((el) => el.id === params.row.id));
                setDialogOpen(true);
              }}
              disabled={selectedEdit?.deliveryTypeDTO !== 'LELKES_SELF_PRINT' && !!selectedEdit}>
              <MdEdit
                color={
                  selectedEdit?.deliveryTypeDTO === 'LELKES_SELF_PRINT'
                    ? 'var(--primary-background-secondary)'
                    : 'disabled'
                }
              />
            </IconButton>
            <IconButton
              onClick={() => {
                setSureOpen(params.row.id);
              }}
              disabled={selectedEdit?.deliveryTypeDTO !== 'LELKES_SELF_PRINT' && !!selectedEdit}>
              <MdDelete
                color={selectedEdit?.deliveryTypeDTO === 'LELKES_SELF_PRINT' ? 'var(--primary-error)' : 'disabled'}
              />
            </IconButton>
          </div>
        );
      }
    }
  ];

  const [formDataEdit, setFormDataEdit] = useState({
    name: '',
    description: '',
    category: 'category',
    priority: 1,
    unitPrice: {
      netAmount: 0,
      grossAmount: 0,
      vatAmount: 0,
      taxRate: 0,
      currency: 'HUF'
    },
    enabled: true,
    additionalModifiers: [],
    compatibleGroup: 0
  });

  useEffect(() => {
    if (selectedEdit !== null) {
      setFormDataEdit({
        ...selectedEdit
      });
      setIsEditing(false);
    }
  }, [selectedEdit]);

  return (
    <Grow in={true}>
      <div className={styles.editContainer}>
        <div className={styles.editHeader}>
          <div className={styles.title}>{t('templates.updateProductCategory')}</div>
          <Button
            className={styles.buttonClose}
            onClick={() => {
              onClose();
            }}>
            <MdClose size={'30px'} />
          </Button>
        </div>
        <div className={styles.editMainContainer}>
          <Formik
            validationSchema={productTypeValidator}
            validate={false}
            enableReinitialize
            initialValues={formDataEdit}
            onSubmit={(values, { setSubmitting, resetForm }) => {
              handleSubmit(values);
              resetForm();
            }}>
            {({ values, handleChange, handleSubmit, errors, touched }) => (
              <form className={styles.leftEdit}>
                <TextField
                  variant='outlined'
                  label={t('common.name')}
                  name='name'
                  size='small'
                  disabled={(selectedEdit?.deliveryTypeDTO !== 'LELKES_SELF_PRINT' && !!selectedEdit) || !isEditing}
                  value={
                    t(`templates.productTypes.${values.name}`) != `templates.productTypes.${values.name}`
                      ? t(`templates.productTypes.${values.name}`)
                      : values.name
                  }
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  error={touched.name && Boolean(errors.name)}
                  helperText={touched.name && errors.name}></TextField>
                <TextField
                  variant='outlined'
                  label={t('common.description')}
                  name='description'
                  size='small'
                  disabled={(selectedEdit?.deliveryTypeDTO !== 'LELKES_SELF_PRINT' && !!selectedEdit) || !isEditing}
                  value={
                    t(`templates.productTypes.${values.description}`) != `templates.productTypes.${values.description}`
                      ? t(`templates.productTypes.${values.description}`)
                      : values.description
                  }
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  error={touched.description && Boolean(errors.description)}
                  helperText={touched.description && errors.description}></TextField>

                <Button
                  disabled={
                    (selectedEdit?.deliveryTypeDTO !== 'LELKES_SELF_PRINT' && !!selectedEdit) ||
                    createModifier.isPending ||
                    updateModifier.isPending ||
                    createPrio2Modifier.isPending ||
                    updatePrio2Modifier.isPending
                  }
                  onClick={() =>
                    selectedEdit === null ? handleSubmit() : isEditing ? handleSubmit() : setIsEditing(true)
                  }
                  type={!isEditing ? 'submit' : 'button'}>
                  {createModifier.isPending || updateModifier.isPending ? (
                    <CircularProgress size={23} />
                  ) : selectedEdit === null ? (
                    t('templates.createProductCategory')
                  ) : isEditing ? (
                    t('templates.saveProductCategory')
                  ) : (
                    t('templates.editProductCategory')
                  )}
                </Button>
                {isEditing && selectedEdit?.deliveryTypeDTO === 'LELKES_SELF_PRINT' && (
                  <Button
                    onClick={() => {
                      setIsEditing(false);
                    }}>
                    {t('common.cancel')}
                  </Button>
                )}
                {!!selectedEdit ? (
                  datagridData.length > 0 && selectedEdit?.deliveryTypeDTO === 'LELKES_SELF_PRINT' ? (
                    <Tooltip title={t('templates.deleteProductCategoryTooltip')}>
                      <span style={{ textAlign: 'center' }}>
                        <Button onClick={() => {}} disabled>
                          {t('templates.deleteProductCategory')}
                          <MdDelete size={'25px'} color='var(--primary-error)' />
                        </Button>
                      </span>
                    </Tooltip>
                  ) : (
                    <Button
                      onClick={() => {
                        deleteModifier.mutate({ modifierId: selectedEdit.id, setOpen: setIsEdit });
                      }}>
                      {t('templates.deleteProductCategory')}
                      <MdDelete size={'25px'} color='var(--primary-error)' />
                    </Button>
                  )
                ) : null}
              </form>
            )}
          </Formik>
          <Divider />
          <div className={styles.rightEdit}>
            {(selectedEdit?.deliveryTypeDTO === 'LELKES_SELF_PRINT' || !selectedEdit) && (
              <Button
                disabled={!selectedEdit}
                className={styles.buttonAdd}
                onClick={() => {
                  setDialogOpen(true);
                }}>
                {t('templates.addNewProduct')}
                <MdAdd size={'25px'} />
              </Button>
            )}

            <DataGrid columns={columns} rows={datagridData} filterMode='client'></DataGrid>
          </div>
        </div>
        <ProductTypeDialog
          open={dialogOpen}
          onClose={handleDialogClose}
          onSubmit={handleDialogSubmit}
          selectedEdit={selectedEdit}
          edit={edit}
        />
        <ConfirmDialog
          open={sureOpen}
          onClose={() => setSureOpen(null)}
          title={t('templates.deleteConfirm')}
          onOk={() => deleteModifier.mutate({ modifierId: sureOpen, setOpen: setSureOpen })}
          multipleButtons={true}
          functionButtonText={t('common.delete')}
          closeButtonText={t('common.cancel')}
        />
      </div>
    </Grow>
  );
};

export default ProductTypeEditor;
